import { use, useId } from 'react';

import { FieldContext, type FieldWiring } from './FormField';

/**
 * Reads the wiring the enclosing {@link FormField} supplies.
 *
 * Outside a field the control still needs an id — a combobox or a date picker
 * has internal parts that must reference it — so a standalone id is generated
 * rather than throwing. What is *not* invented is a label: a control used
 * outside a field is responsible for its own accessible name, and the a11y
 * suite fails it if it has none.
 *
 * @returns the field wiring, or a standalone equivalent
 */
export function useFieldWiring(): FieldWiring {
  const fallbackId = useId();
  const field = use(FieldContext);

  return (
    field ?? {
      controlId: `${fallbackId}-control`,
      describedBy: undefined,
      invalid: false,
      required: false,
    }
  );
}
